import React from 'react'
import { motion } from 'framer-motion'
import { Shield, Zap, Users, Gift, Lock, Smartphone } from 'lucide-react'

const Features = () => {
  const features = [
    {
      icon: Shield,
      title: "100% Seguro",
      description: "Sistema de pago seguro y números únicos garantizados. Tu participación está protegida.",
      color: "from-green-500 to-emerald-600"
    },
    {
      icon: Zap,
      title: "Membresías Rápidas",
      description: "Resultados instantáneos y transparentes. Conoce si ganaste al momento de la membresía.",
      color: "from-yellow-500 to-orange-600"
    },
    {
      icon: Lock,
      title: "Números Únicos",
      description: "Cada número se vende una sola vez. 100,000 números únicos por membresía garantizados.",
      color: "from-blue-500 to-cyan-600"
    },
    {
      icon: Gift,
      title: "Premios Increíbles",
      description: "Desde efectivo hasta dispositivos de última generación y experiencias únicas.",
      color: "from-purple-500 to-pink-600"
    },
    {
      icon: Users,
      title: "Comunidad Activa",
      description: "Únete a miles de participantes y comparte la emoción de ganar juntos.",
      color: "from-indigo-500 to-purple-600"
    },
    {
      icon: Smartphone,
      title: "Fácil de Usar",
      description: "Interfaz intuitiva y moderna. Compra tus boletos en segundos desde cualquier dispositivo.",
      color: "from-teal-500 to-green-600"
    }
  ]

  return (
    <section className="py-20 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            ¿Por qué elegir
            <span className="gradient-text block">ParaisoTour?</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Ofrecemos la experiencia de membresías más segura, transparente y emocionante del mercado
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
                className="card-modern p-8 group cursor-pointer"
              >
                <div className="space-y-4">
                  {/* Icon */}
                  <div className={`inline-flex p-4 rounded-xl bg-gradient-to-r ${feature.color} shadow-lg group-hover:shadow-xl transition-all duration-300`}>
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                  
                  {/* Content */}
                  <div>
                    <h3 className="text-xl font-bold text-white mb-3 group-hover:text-primary-400 transition-colors">
                      {feature.title}
                    </h3>
                    <p className="text-gray-300 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
                
                {/* Hover Effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-primary-500/5 to-secondary-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </motion.div>
            )
          })}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <div className="card-modern p-8 lg:p-12 max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-white mb-4">
              ¿Listo para ganar?
            </h3>
            <p className="text-gray-300 mb-8 text-lg">
              Únete a nuestra comunidad y participa en membresías exclusivas con las mejores probabilidades de ganar
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="btn-primary text-lg px-8 py-4"
              >
                Ver Membresías Activas
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-white/10 backdrop-blur-lg border border-white/20 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 hover:bg-white/20"
              >
                Crear Cuenta Gratis
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Features